var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 3.5,
    stroke: "#4281C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95959 8.95959C7.68345 8.68345 7.68345 8.23574 7.95959 7.9596C8.23573 7.68346 8.68345 7.68346 8.95959 7.95961L10.4698 9.46993C10.746 9.74605 10.746 10.1937 10.4699 10.4698C10.1937 10.746 9.74602 10.746 9.46988 10.4699L7.95959 8.95959Z",
    fill: "#4281C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14136 7.85864L7.84846 7.15154L9.90519 9.20833L9.19816 9.91543L7.14136 7.85864Z",
    fill: "#4281C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.adc532aeff56dc0e153a8aae52800112.svg";
export { ForwardRef as ReactComponent };